
import { Component, Vue, Prop } from "vue-property-decorator"
import ChartOptions from "./ChartOptions.vue"

@Component({
	components: {
		"chart-options": ChartOptions
	}
})
export default class ChartOptionsDropdown extends Vue {
	@Prop()
	value: unknown

	@Prop({ default: "ColumnChart" })
	chartType: any

	@Prop()
	columns!: any[]

	@Prop()
	chartData: unknown

	@Prop({ type: Boolean, default: false }) disabled!: boolean

	private doesChartTypeHaveOptionsAvailable = true;

	private get isDisabled (): boolean {
		return this.disabled || !this.doesChartTypeHaveOptionsAvailable
	}
}

